import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import FormInputFile from './file/FormInputFile';


const FileModal = ({ title, show, setShow, files, setFiles, fileNameField, filePathField, privateView }) => {


  const handleCloseImagesModal = () => {
    setShow(false);
    setFiles([]);
  };

  return (
    <Modal show={show} size={privateView ? 'xl' : 'sm'} onHide={handleCloseImagesModal}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate>

          <FormInputFile
            titleText={''}
            labelText={'Wybierz plik'}
            idName={'title'}
            path={'file'}
            inputSize={9}
            btnSize={3}
            fileNameField={fileNameField || 'fileName'}
            filePathField={filePathField || 'filePath'}
            requestParameterName={'file'}
            setImagesParentStore={setFiles}
            list={true}
            imagesParentStore={files}
            disabled={true}
            privateView={privateView}
          />

        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleCloseImagesModal}>Kontynuuj</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FileModal;